// @core/api/endpoints/analytics/create_widget.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateWidgetRequest,
  WidgetResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Create widget
 * Creates a new widget on a dashboard with the specified visualization type and data source.
 */
export async function CreateWidget(
  dashboard_id: string,
  data: CreateWidgetRequest,
  options?: RequestOptions
): Promise<WidgetResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id/widgets`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.post<WidgetResponse>(requestPath, data, requestOptions);
}
